<template>
  <div>
    <div v-if="cebelcaAccountAvailable === false">
      <form class="form-container" @submit.prevent="createCebelcaAccount">
        <br />
        <br />
        <input
          :placeholder="$t('email')"
          :disabled="true"
          v-model="email"
          :class="{ 'error-boarder': $v.email.$error }"
          type="email"
          name="email"
          @blur="$v.email.$touch()"
          value
        />
        <input
          class="user-input"
          :placeholder="$t('password')"
          v-model="password"
          :class="{ 'error-boarder': $v.password.$error }"
          :type="passwordFieldType"
          name="password"
          maxlength="22"
          @blur="$v.password.$touch()"
          value
        />

        <button class="eyeIcon" type="button" @click="switchVisibility">
          <span class="input-group-text" @click="showPassword = !showPassword">
            <i
              class="fa"
              :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
              aria-hidden="true"
            ></i>
          </span>
        </button>
        <div class="errorField">
          <template v-if="$v.password.$error">
            <div v-if="!$v.password.required" class="errorMessage2">
              {{ $t('passReq') }}
            </div>
          </template>
          <template v-if="$v.password.$invalid">
            <p v-if="!$v.password.maxLength" class="errorMessage2">
              {{ $t('passMaxLength') }}
            </p>
          </template>
          <!-- <template v-if="$v.password.$invalid">
						<p v-if="!$v.password.minLength" class="errorMessage2">
							{{ $t('passMinLength') }}
						</p>
					</template> -->
          <template v-if="this.submitted && $v.password.$error">
            <p v-if="password && !$v.password.valid" class="errorMessage2">
              {{ $t('passValid') }}
            </p>
          </template>
        </div>

        <button
          class="add-btn"
          type="submit"
          name="button"
          data-qa="signUpCebelcaBtn"
          :disabled="$v.password.$invalid"
        >
          {{ $t('createCebelcaAccount') }}
        </button>
        <br />
        <div class="options-01">
          <a
            class="alreadyAccount"
            @click="$bvModal.show('already-cebelca-account')"
            >{{ $t('alreadyCebelcaAccount') }}</a
          >
        </div>

        <ul>
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
      </form>
      <sweet-modal icon="success" ref="modalSuccessAccount">
        {{ $t('accountCreated') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalErrorAccount">
        {{ accountCreationResponse }}
        <sweet-button slot="button"> {{ $t('tryAgain') }}</sweet-button>
      </sweet-modal>
    </div>
    <div v-else-if="cebelcaCertificateUploaded === false">
      <form class="form-container" @submit.prevent="uploadCertificate">
        <br />
        <label style="font-size:1.2rem;" for="uploadFieldName">{{
          $t('uploadP12Certificate')
        }}</label>
        <input
          type="file"
          :name="uploadFieldName"
          :disabled="isSaving"
          accept=".p12"
          class="input-file"
          ref="file"
          @change="filesChange()"
        />
        <input
          :placeholder="$t('password')"
          v-model="certificatePassword"
          :class="{ 'error-boarder': $v.certificatePassword.$error }"
          :type="passwordFieldType"
          maxlength="22"
          name="certificatePassword"
          @blur="$v.certificatePassword.$touch()"
          value
        />
        <button class="eyeIcon" type="button" @click="switchVisibility">
          <span class="input-group-text" @click="showPassword = !showPassword">
            <i
              class="fa"
              :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
              aria-hidden="true"
            ></i>
          </span>
        </button>
        <template v-if="$v.certificatePassword.$error">
          <div v-if="!$v.certificatePassword.required" class="errorMessage2">
            {{ $t('passReq') }}
          </div>
        </template>
        <button
          class="add-btn"
          type="submit"
          name="button"
          data-qa="certificatePasswordCebelcaBtn"
          :disabled="$v.certificatePassword.$invalid"
        >
          {{ $t('upload') }}
        </button>

        <sweet-modal
          icon="success"
          ref="modalSuccessCertificate"
          name="successModal"
        >
          <br />
          <p v-if="certificateResponse">{{ $t('certificateUploadSuccess') }}</p>
        </sweet-modal>
        <sweet-modal icon="error" ref="modalErrorCertificate" name="errorModal">
          <p v-if="certificateResponse">{{ certificateResponse }}</p>
        </sweet-modal>

        <ul>
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
      </form>
    </div>
    <div v-else>
      {{ $t('cebelcaAccountSuccess') }}
    </div>

    <b-modal id="already-cebelca-account" hide-footer>
      <template v-slot:modal-title>
        {{ $t('copyCebelcaToken') }}
        <b-button
          class="questionMark"
          v-b-tooltip.hover
          :title="$t('tooltipCebelca')"
          >?</b-button
        >
      </template>
      <input
        v-model="token"
        type="token"
        name="token"
        :placeholder="$t('token')"
        @blur="$v.token.$touch()"
        :class="{ 'error-boarder': $v.token.$error }"
      />
      <template v-if="$v.token.$error">
        <div v-if="!$v.token.required" class="errorMessage">
          {{ $t('tokenReq') }}
        </div>
      </template>
      <p>
        <button
          class="add-btn"
          style="width: 200px;"
          :disabled="$v.token.$invalid"
          @click="saveToken"
        >
          {{ $t('save') }}
        </button>
      </p>
    </b-modal>
    <sweet-modal icon="success" ref="modalSuccessToken" name="successModal">
      {{ $t('tokenSaveSuccess') }}
    </sweet-modal>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import ClientService from '@/services/ClientService.js'
import CebelcaService from '@/services/CebelcaService.js'

export default {
  // 	metaInfo() {
  //     return {
  //       title: this.$i18n.t('taxVerification'),
  //     }
  //   },
  data() {
    return {
      email: '',
      password: '',
      certificatePassword: '',
      token: '',
      errors: null,
      error: false,
      cebelcaAccountAvailable: false,
      cebelcaCertificateUploaded: false,
      certificateFile: null,
      accountCreationResponse: null,
      certificateResponse: null,
      passwordFieldType: 'password',
      showPassword: false,
      submitted: false
    }
  },
  validations: {
    email: {
      // required,
    },
    password: {
      required,
      valid: function(value) {
        const containsUppercase = /[A-Z]/.test(value)
        const containsLowercase = /[a-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        const containsSpecial = /[ §"()=#?!@$%^&₹*-/_:;.'<>`[~{}|]/.test(value)
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        )
      },
      maxLength: maxLength(20)
      // minLength: minLength(8)
    },
    certificateFile: {
      required
    },
    certificatePassword: {
      required
    },
    token: {
      required
    }
  },
  async mounted() {
    const user = JSON.parse(localStorage.getItem('user'))
    this.email = user.email
    await ClientService.getClientDetails().then(async response => {
      if (response.data && response.data.length > 0) {
        const clientDetails = response.data[0]
        if (clientDetails.location_id && clientDetails.location_id !== null) {
          this.cebelcaAccountAvailable = true
          this.checkCebelcaCertificate()
        }
      }
    })
  },
  created() {
    this.submitted = true
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid
    }
  },
  methods: {
    async createCebelcaAccount() {
      if (this.$v.email.$invalid || this.$v.password.$invalid) {
        alert('Please complete fields as required')
      } else {
        const body = {
          email: this.email,
          password: this.password
        }
        this.$store
          .dispatch('client/createCebelcaAccount', body)
          .then(response => {
            this.accountCreationResponse = response.message
            if (response.error && response.error === true) {
              if (this.accountCreationResponse === 'email address taken') {
                alert(this.$t('AddCebelcaToken'))
                this.$bvModal.show('already-cebelca-account')
              } else {
                if (this.source === 'FIRST_MODAL') {
                  alert(this.accountCreationResponse)
                } else {
                  this.$refs.modalErrorAccount.open()
                }
              }
            } else {
              this.cebelcaAccountAvailable = true
              if (this.source === 'FIRST_MODAL') {
                alert(this.$t('accountCreated'))
              } else {
                this.$refs.modalSuccessAccount.open()
              }
            }
          })
          .catch(error => {
            // catch the error
            console.log(error)
          })
        this.submitted = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          return false // stop here if form is invalid
          // console.log("form submitted:", this.email);
        }
      }
    },
    filesChange() {
      this.certificateFile = this.$refs.file.files[0]
    },
    uploadCertificate() {
      if (
        this.$v.certificateFile.$invalid ||
        this.$v.certificatePassword.$invalid
      ) {
        alert('Please complete fields as required')
      } else {
        const formData = new FormData()
        formData.append('file', this.certificateFile)
        formData.append('password', this.certificatePassword)

        CebelcaService.uploadCebelcaCertificate(formData)
          .then(response => {
            this.certificateResponse = response.data.message
            if (response.data.type === 'success') {
              this.cebelcaCertificateUploaded = true
              if (this.source === 'FIRST_MODAL') {
                alert(this.$t('certificateUploadSuccess'))
                this.$emit('completeCebelcaStep', null)
              } else {
                this.$refs.modalSuccessCertificate.open()
              }
            } else {
              if (this.source === 'FIRST_MODAL') {
                alert(this.certificateResponse)
              } else {
                this.$refs.modalErrorCertificate.open()
              }
            }
          })
          .catch(() => {
            alert(`something wrong while uploading certificate`)
          })
      }
    },
    saveToken() {
      if (this.$v.token.$invalid) {
        alert('Please complete fields as required')
      } else {
        const body = {
          token: this.token
        }
        this.$store
          .dispatch('client/connectCebelcaAccount', body)
          .then(response => {
            if (response.error && response.error === true) {
              if (this.source === 'FIRST_MODAL') {
                alert(this.accountCreationResponse)
              } else {
                this.$refs.modalErrorAccount.open()
              }
            } else {
              this.cebelcaAccountAvailable = true
              if (this.source === 'FIRST_MODAL') {
                alert(this.$t('tokenSaveSuccess'))
              } else {
                this.$refs.modalSuccessToken.open()
              }
              this.$bvModal.hide('already-cebelca-account')
              this.checkCebelcaCertificate()
            }
          })
          .catch(error => {
            // catch the error
            console.log(error)
          })
      }
    },
    checkCebelcaCertificate() {
      this.$store
        .dispatch('client/checkFiscalisationCertUploaded')
        .then((response) => {
          if (response.type === 'success') {
            this.cebelcaCertificateUploaded = true
            if (this.source === 'FIRST_MODAL') {
              this.$emit('completeCebelcaStep', null)
            }
          }
        })
        .catch(() => {
          this.cebelcaCertificateUploaded = false
        })
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  },
  props: {
    source: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  //position: absolute;
  margin-top: 20px;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
  width: 50%;
}
.errorField {
  width: 80%;
}
.user-input {
  display: inline-flex;
}

.eyeIcon {
  position: relative;
  justify-content: end !important;
  margin-left: auto !important;
  top: -58px;
  width: 40px;
  right: 60px !important;
  background: none;
}

.input-group-text {
  background: none !important;
  border: none !important;
}

a:visited {
  color: #2c3e50;
}

.questionMark {
  display: inline;
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  width: inherit;
  font-size: 1em;
  background: var(--bg) !important;
  margin: 0 px;
  padding: 0 10px;
}

.questionMark:hover {
  background: var(--primaryDark) !important;
}
.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  border-radius: 5px;
  letter-spacing: 3px;
  width: 80%;
  margin: 1em auto;
  text-transform: uppercase;
}

input[type='file'] {
  border-style: none;
  height: 70px;
}

input[type='token'] {
  width: 100%;
}

input[type='file']::file-selector-button {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 1px;
  border-style: none;
  width: 100%;
  border-radius: 5px;
  width: 150px;
  height: 45px;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  width: 80%;
  margin-top: 1em;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

form {
  display: flex;
  align-items: center;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  border-style: solid;
  width: 80%;
  height: 2.6em;
  padding: 0.5em;
  margin-top: 2em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

h1 {
  margin-top: 0;
}

.errorMessage {
  font-size: 0.8em;
  color: var(--primaryDark);
}
.errorMessage2 {
  font-size: 0.7em;
  text-align: left;
  color: var(--primaryDark);
  margin-top: -40px;
}
.errorMessage3 {
  font-size: 0.7em;
  text-align: left;
  color: var(--primaryDark);
  margin-left: 40px;
  margin-right: 100px;
  margin-top: -45px;
}
.error-boarder {
  border: 2px solid var(--primaryDark);
}
.alreadyAccount {
  color: var(--bgDark) !important;
  background-color: none !important;
  text-decoration-line: none;
  cursor: pointer;
}
.alreadyAccount:hover {
  text-decoration-line: underline;
}

.alreadyAccount:active {
  color: var(--primary) !important;
  text-decoration-line: none;
}
@media screen and (max-width: 500px) {
  .form-container {
    padding: 0px;
    width: 90%;
  }
  .add-btn {
    letter-spacing: 1px;
  }
  .eyeIcon {
    right: 30px !important;
    top: -50px;
  }

  button {
    font-size: 1em;
  }

  .options-01 {
    margin: 0 20px;
  }
}
@media screen and (min-width: 501px) and (max-width: 740px) {
  .eyeIcon {
    right: 20px !important;
    top: -58px;
  }
}
@media screen and (min-width: 540px) {
  .errorMessage {
    margin-left: -320px;
  }
}
@media screen and (min-width: 741px) {
  .eyeIcon {
    right: 45px;
    top: -60px;
  }
}

@media screen and (min-width: 1485px) {
  .eyeIcon {
    right: 80px;
    top: -60px;
  }
}
</style>
